import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'google-react-maps';
const c = o => JSON.parse(JSON.stringify(o));

class ContactMarker extends Component {
  constructor(props, ...args) {
    super(props, ...args);
  }
  render() {
    const { contact } = this.props;
    const [ lng, lat ] = contact.address.feature.geometry.coordinates;

    if(isNaN(lng) || isNaN(lat)) {
      return null;
    }

    return (
      <Marker {...this.props} coords={{lng, lat}} />
    );
  }
}

export default ContactMarker;



// WEBPACK FOOTER //
// ./src/browser/components/clients/contact-marker.js